// Generated by @repo/server. Do not edit.
import { z } from "zod";

export const emailSchema = z.looseObject({
  objectId: z.string(),
  id: z.string().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  categories: z.array(z.string()).nullable().optional(),
  title: z.string().nullable(),
  active: z.boolean().nullable().optional(),
});

export const locationSchema = z.looseObject({
  objectId: z.string(),
  id: z.string().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  categories: z.array(z.string()).nullable().optional(),
  title: z.string().nullable(),
  description: z.string().nullable().optional(),
  coordinates: z.object({ latitude: z.number(), longitude: z.number() }).nullable().optional(),
  data: z.object({
    strasse: z.string().nullable().optional(),
    plz: z.string().nullable().optional(),
    ort: z.string().nullable().optional(),
    tel: z.string().nullable().optional(),
    fax: z.string().nullable().optional(),
    email: z.string().nullable().optional(),
    homepage: z.string().nullable().optional(),
    kompetenzzentrum: z.string().nullable().optional(),
  }).nullable().optional(),
});

export const eventSchema = z.looseObject({
  objectId: z.string(),
  id: z.string().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  categories: z.array(z.string()).nullable().optional(),
  title: z.string().nullable(),
  description: z.string().nullable().optional(),
  text: z.string().nullable().optional(),
  image: z.string().nullable().optional(),
  gallery: z.array(z.string()).nullable().optional(),
  dates: z.array(z.any()).nullable().optional(),
  link: z.string().nullable().optional(),
  documents: z.array(z.string()).nullable().optional(),
});

export const personSchema = z.looseObject({
  objectId: z.string(),
  id: z.string().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  categories: z.array(z.string()).nullable().optional(),
  title: z.string().nullable(),
  description: z.string().nullable().optional(),
  text: z.string().nullable().optional(),
  image: z.string().nullable().optional(),
  email: z.string().nullable().optional(),
  data: z.object({
    order: z.union([z.string(), z.number()]).nullable().optional(),
  }).nullable().optional(),
});

export const categorySchema = z.looseObject({
  objectId: z.string(),
  id: z.string().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  categories: z.array(z.string()).nullable().optional(),
});

export const entrySchema = z.looseObject({
  objectId: z.string(),
  id: z.string().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  categories: z.array(z.string()).nullable().optional(),
  title: z.string().nullable(),
  description: z.string().nullable().optional(),
  text: z.string().nullable().optional(),
  image: z.string().nullable().optional(),
  date: z.string().nullable().optional(),
  link: z.string().nullable().optional(),
  documents: z.array(z.string()).nullable().optional(),
  file: z.object({ __typename: z.string().optional(), name: z.string().optional(), url: z.string() }).nullable().optional(),
  filePath: z.string().optional(),
});

export const downloadSchema = z.looseObject({
  objectId: z.string(),
  id: z.string().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  categories: z.array(z.string()).nullable().optional(),
  title: z.string().nullable(),
  description: z.string().nullable().optional(),
  file: z.object({ __typename: z.string().optional(), name: z.string().optional(), url: z.string() }).nullable().optional(),
  date: z.string().nullable().optional(),
  filePath: z.string().optional(),
});

export const webpageSchema = z.looseObject({
  objectId: z.string(),
  id: z.string().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  categories: z.array(z.string()).nullable().optional(),
  title: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  image: z.string().nullable().optional(),
});

export const imageSchema = z.looseObject({
  objectId: z.string(),
  id: z.string().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  categories: z.array(z.string()).nullable().optional(),
  title: z.string().nullable(),
  description: z.string().nullable().optional(),
  text: z.string().nullable().optional(),
  connected_elements: z.array(z.any()).nullable().optional(),
  file: z.object({ __typename: z.string().optional(), name: z.string().optional(), url: z.string() }).nullable().optional(),
  filePath: z.string().optional(),
});

export const userSchema = z.looseObject({
  objectId: z.string(),
  id: z.string().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  categories: z.array(z.string()).nullable().optional(),
  pre_title: z.string().nullable().optional(),
  post_title: z.string().nullable().optional(),
  salutation: z.string().nullable().optional(),
  first_name: z.string().nullable().optional(),
  last_name: z.string().nullable().optional(),
  username: z.string().nullable().optional(),
  email: z.string().nullable().optional(),
  roles: z.string().nullable().optional(),
  location: z.string().nullable().optional(),
  emails: z.array(z.string()).nullable().optional(),
  expires_at: z.string().nullable().optional(),
  data: z.object({
    "bcd.klinikposition": z.string().nullable().optional(),
    "bcd.fachrichtung": z.string().nullable().optional(),
    "bcd.belegklinik": z.string().nullable().optional(),
    "bcd.tel": z.string().nullable().optional(),
    "bcd.fax": z.string().nullable().optional(),
    "bcd.email": z.string().nullable().optional(),
    "bcd.man_ref": z.string().nullable().optional(),
    "bcd.spezialist": z.string().nullable().optional(),
    "bcd.order": z.union([z.string(), z.number()]).nullable().optional(),
  }).nullable().optional(),
});

export const applicationSchemas = {
  Email: emailSchema,
  Location: locationSchema,
  Event: eventSchema,
  Person: personSchema,
  Category: categorySchema,
  Entry: entrySchema,
  Download: downloadSchema,
  Webpage: webpageSchema,
  Image: imageSchema,
  User: userSchema,
} as const;

export type Application = {
  [K in keyof typeof applicationSchemas]: z.infer<(typeof applicationSchemas)[K]>;
};

declare module "@repo/server" {
  interface ApplicationModules {
    Email: z.infer<typeof emailSchema>;
    Location: z.infer<typeof locationSchema>;
    Event: z.infer<typeof eventSchema>;
    Person: z.infer<typeof personSchema>;
    Category: z.infer<typeof categorySchema>;
    Entry: z.infer<typeof entrySchema>;
    Download: z.infer<typeof downloadSchema>;
    Webpage: z.infer<typeof webpageSchema>;
    Image: z.infer<typeof imageSchema>;
    User: z.infer<typeof userSchema>;
  }
}
